var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.399 1.75895C19.3371 1.44624 20.2296 2.33873 19.9169 3.27684L14.8603 18.4467C14.5319 19.4318 13.192 19.5631 12.6787 18.6603L9.58358 13.2172C9.31667 12.7478 8.92801 12.3591 8.45861 12.0922L3.01551 8.99712C2.11278 8.4838 2.24402 7.14394 3.2292 6.81555L18.399 1.75895Z",
    stroke: "#0D4740",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.93279 10.2148L8.17188 12.2148",
    stroke: "#0D4740",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.f2449053b8bd3b4f29d512917ce2a3a3.svg";
export { ForwardRef as ReactComponent };